import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-account-info',
  templateUrl: './account_info.component.html',
  styles: []
})
export class AccountInfoComponent implements OnInit {
  @Input() childAccount; // account object
  @Input() childStudent; // student object
  @Input() childProject; // project & course object

  @Input() childProjectCourse; // special case for want display project and course

  constructor(
  ) { 
  // why <br/> also have ngIf ? because when there's no data rendered, <br/> will cause white space
  }

  ngOnInit() {
    // console.log(this.childAccount);
  }

}



// WEBPACK FOOTER //
// ./src/app/component/shared/account_component/account_info.component.ts